export const AndroidReferrer = "android-app://com.senecalearning.app";
export const AndroidTWAParamKey = "isAndroidPWA";
